import {
  IMaintenanceConfig,
  IMaintenanceBanner,
} from "./maintenanceConfig.types"

export class MaintenanceBanner implements IMaintenanceBanner {
  constructor(
    public title: string,
    public message: string,
    public pages: string[],
  ) {}
}

export class MaintenanceConfig implements IMaintenanceConfig {
  constructor(
    public isMaintenanceBannerEnabled: boolean,
    public maintenanceBannerContent: IMaintenanceBanner,
  ) {}
}
